import { render, staticRenderFns } from "./MatchGroup.vue?vue&type=template&id=6fb67d0c&scoped=true&"
import script from "./MatchGroup.vue?vue&type=script&lang=js&"
export * from "./MatchGroup.vue?vue&type=script&lang=js&"
import style0 from "@/tbs/stylesheet/dynamic.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./MatchGroup.vue?vue&type=style&index=1&id=6fb67d0c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb67d0c",
  null
  
)

export default component.exports